import React from 'react';
import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';
import { IconCheveronRight } from '../Icons';

const FeatureButton = ({ icon, title, subtitle, className, onClick, badge }) => {
  const cn = useClassNames(
    () => [
      'focus:outline-none',
      'flex',
      'border',
      'rounded-lg',
      'p-2',
      'group',
      'hover:shadow-sm',
      'h-24',
      'items-center',
      'hover:bg-slate-50',
      className,
    ],
    [className],
  );

  return (
    <button type="button" onClick={onClick} className={cn}>
      <div className="flex items-center justify-center w-20 group-hover:text-blue-700 text-blue-500">
        {icon}
      </div>
      <div className="flex-1 text-left flex flex-col text-slate-600">
        <div className="font-semibold mb-0 lg:mb-1 last:mb-0 flex items-center">
          <div>{title}</div>
          {badge && <div className="ml-2">{badge}</div>}
        </div>
        {subtitle && <div className="hidden lg:block">{subtitle}</div>}
      </div>
      <div className="flex items-center text-slate-400 group-hover:text-slate-500 lg:ml-10">
        <IconCheveronRight size="12" />
      </div>
    </button>
  );
};

FeatureButton.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  badge: PropTypes.node,
};

FeatureButton.defaultProps = {
  onClick: () => {},
};

export default FeatureButton;
